module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/typography/table-scroll-desktop-160/table-scroll-desktop-160.component.scss
// module id = ./src/app/features/typography/table-scroll-desktop-160/table-scroll-desktop-160.component.scss
// module chunks = main